module.exports = __webpack_public_path__ + "img/mask-product.239526fe.png";